import React from "react"
import classnames from "classnames"
import { AccordionText } from "AtomicContainers"
import componentParser from "AtomicUtils/componentParser";
import styles from "./AccordionTextList.less"

class AccordionTextList extends React.Component {

  render() {
    const { data, styleName="box", components, alwaysOpen, gtm } = this.props
    if (!components && (!data || data === "" || data === undefined)) return ""
    if (!data && components) {
      components.map(item => {
        if (item.props.gtm && item.props.gtm.category && item.props.gtm.action) return item
        item.props.gtm = gtm
      })
    }

    return (
      <div
        className={classnames({
          [styles.AccordionTextList]: true
        })}>

          {data && !Array.isArray(data) &&
          <AccordionText
            status={alwaysOpen?1:0}
            styleName={styleName}
            title={data.title}
            gtm={gtm}
            {...data}
          >
            {data.description}
          </AccordionText>}


          {data && Array.isArray(data) && data.map((item,index)=>{
            return (
              <AccordionText
                status={alwaysOpen?1:0}
                styleName={styleName}
                key={`AccordionText-${index}`}
                title={item.title}
                gtm={gtm}
                {...item}
              >
              {item.description}
              </AccordionText>
            )
          })}

          {!data && components &&
            componentParser(components)
          }
      </div>
    )
  }
}


export default AccordionTextList



// WEBPACK FOOTER //
// ./src/AtomicContainers/AccordionTextList/AccordionTextList.jsx